import http from "@/common/http.service";
const ROOT_URL = "logs/";
const LOG_FILTER_URL = "log-filters/";
const IMPORT_LOG_DOWNLOAD = "import-log-summary/download";
export default {
  fetchItems(type, params, cb) {
    http.post(ROOT_URL + type, params).then(function (response) {
      var data = { items: response.data.data, total: response.data.totalRows };
      cb(data);
    });
  },
  fetchFilters(type, params, cb) {
    http.post(LOG_FILTER_URL + type, params).then(function (response) {
      var data = { filterData: response.data };
      cb(data);
    });
  },
  downloadSummary(params) {
    return http.downLoad(IMPORT_LOG_DOWNLOAD, params);
  },
};
